import { filter } from 'lodash';
import cloneDeep from 'lodash.clonedeep';
import types from './actionTypes';
import fields from '../../../test/fields'

// const initialState = fields

const initialState = []


export default function appReducer(state = initialState, action) {
    // console.log("app reducer", action)
    switch (action.type) {
        case types.ADD_FIELD: {
            return [
            ...state, 
            action.payload
            ]            
        }

        case types.EDIT_FIELD: {
            return [ ...state.map( field => field.id == action.payload.id ? (action.payload) : ({ ...field })  )]
        } 

        case types.DELETE_FIELD: {
            return state.filter(field => field.id !== action.payload.id) 
        }

        case types.UPDATE_FULL_FIELDS: {
            return [
                ...state,
                ...action.payload
            ]
        }

        case types.UPDATE_REORDERED_FIELDS: {
            return [...action.payload]
        }

        case 'RESET_BLUEPRINT':
            return cloneDeep(initialState);


        default:
        return state;
    }
  }
  